<template>
  <gj-modal
    size="normal"
    :visible.sync="modalVisible"
    :confirmLoading="confirmLoading"
    @cancel="cancel"
    @confirm="confirm"
  >
    <template #header>添加标签</template>
    <template #content>
      <el-form ref="form" :model="form" label-width="74px">
        <el-form-item
          label="标签名称"
          prop="name"
          :rules="[
            {
              required: true,
              message: '请输入标签名称',
              trigger: ['blur', 'change'],
            },
          ]"
        >
          <gj-input
            v-model="form.name"
            class="form-input"
            width="100%"
            maxlength="40"
            placeholder="请输入标签名称"
          ></gj-input>
        </el-form-item>
        <el-form-item
          label="标签分类"
          prop="parentId"
          :rules="[
            {
              required: true,
              message: '请输入上级分类',
              trigger: ['blur', 'change'],
            },
          ]"
        >
          <gj-tree-select
            v-model="form.parentId"
            :data="treeData"
            class="form-input"
            :clearable="false"
            width="100%"
            :expandOnClickNode="true"
            placeholder="请输入上级分类"
          ></gj-tree-select>
        </el-form-item>

        <el-form-item label="标签备注" prop="memo" style="margin-bottom: 0">
          <gj-textarea
            v-model="form.memo"
            :styles="{ height: '120px', width: '100%' }"
            placeholder="请输入备注内容"
            class="form-input"
          >
          </gj-textarea>
        </el-form-item>
      </el-form>
    </template>
  </gj-modal>
</template>

<script>
import {
  modalMixIn,
  responseMixin,
  formRuleMixin,
} from "../../../../../minxins";
import { tagAdd, getTagTreeList } from "../../../../../api/system";

export default {
  name: "app-tag-add-modal",
  mixins: [modalMixIn, responseMixin, formRuleMixin],
  props: {
    parentId: {
      type: Number,
    },
  },
  data() {
    return {
      confirmLoading: false,
      form: {
        name: null,
        parentId: this.parentId,
        memo: null,
      },
      treeData: [],
    };
  },
  created() {
    this.queryData();
  },
  methods: {
    queryData() {
      this.loading = true;
      getTagTreeList()
        .then((res) => {
          this.treeData = res.data;
        })
        .complete(() => (this.loading = false));
    },
    confirm() {
      if (this.$gjFormValidate()) {
        this.confirmLoading = true;
        const params = {
          fid: this.form.parentId,
          name: this.form.name,
          memo: this.form.memo,
        };
        tagAdd(params)
          .then((res) => {
            this.$gjResponseHandle(res, () => {
              this.$gjMessage.success("新增标签成功");
              this.$emit("created");
              this.$gjDestroy();
            });
          })
          .complete(() => {
            this.confirmLoading = false;
          });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  /deep/ .el-dialog__body{
    padding-bottom: 0;
  }
</style>
